<template functional>
  <div class="appt-pd-lfd" :class="props.item.appt_pd_lfd">
    {{ props.item.per_diem_lfd_fmt }}
  </div>
</template>

<script>
export default {
  name: "drayage-pd-lfd",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
